module.exports = __webpack_public_path__ + "img/lk.d9b19b4f.svg";